// Pluralization rules for unit types
const pluralRules: Record<string, { singular: string; plural: string }> = {
  box: { singular: 'box', plural: 'boxes' },
  packet: { singular: 'packet', plural: 'packets' },
  crate: { singular: 'crate', plural: 'crates' },
  unit: { singular: 'unit', plural: 'units' },
  units: { singular: 'unit', plural: 'units' },
  kg: { singular: 'kg', plural: 'kg' },
  grams: { singular: 'gram', plural: 'grams' },
};

export function pluralizeUnit(quantity: number, unitType: string | null): string {
  const unit = unitType?.toLowerCase() || 'unit';
  const rule = pluralRules[unit];
  
  if (rule) {
    return quantity === 1 ? rule.singular : rule.plural;
  }
  
  // Default pluralization: add 's' if not 1
  return quantity === 1 ? unit : `${unit}s`;
}

export function formatQuantityWithUnit(quantity: number, unitType: string | null): string {
  return `${quantity} ${pluralizeUnit(quantity, unitType)}`;
}
